import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import { getWindowWidth } from '../../store/selectors/ui.selectors';

import ProductCarouselSliderContainer from '../shopping/ProductCarouselSlider';
import ProductCollectionItem from '../shopping/ProductCollectionItem';

export class FeaturedProducts extends Component {
  constructor(props) {
    super(props);

    this.renderGrid = this.renderGrid.bind(this);
    this.renderProductCarousel = this.renderProductCarousel.bind(this);
  }

  renderGrid(productCollectionItems) {
    const {
      history,
    } = this.props;

    return (
      <div className="featured-products__grid">
        {productCollectionItems.map((collectionItem) => (
          <div key={collectionItem.id} className="featured-products__grid-item">
            <ProductCollectionItem
              hideDetails
              history={history}
              collectionItem={collectionItem}
              source="featured-products"
            />
          </div>
        ))}
      </div>
    );
  }

  renderProductCarousel(productCollectionItems) {
    const {
      history,
    } = this.props;

    return (
      <div className="featured-products__carousel">
        <ProductCarouselSliderContainer
          productCollectionItems={productCollectionItems}
          history={history}
        />
      </div>
    );
  }

  render() {
    const {
      anchor,
      header,
      collections,
      isMobile,
    } = this.props;
    const productCollectionItems = collections?.[0]?.productCollectionItems;

    return (
      <section
        id={anchor || undefined}
        className={classNames('featured-products', {
          'featured-products--no-gap-above': !header,
        })}
      >
        {header && (
          <div className="featured-products__header-container" aria-label={header}>
            <h2>{header}</h2>
          </div>
        )}
        {(Array.isArray(productCollectionItems) && productCollectionItems.length) && (
          isMobile
            ? this.renderProductCarousel(productCollectionItems)
            : this.renderGrid(productCollectionItems)
        )}
      </section>
    );
  }
}

FeaturedProducts.defaultProps = {
  collections: [],
};

const productCollectionItemShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  item: PropTypes.shape({}),
  sku: PropTypes.string,
});

const productCollectionShape = PropTypes.shape({
  productCollectionItems: PropTypes.arrayOf(productCollectionItemShape),
});

FeaturedProducts.propTypes = {
  anchor: PropTypes.string,
  header: PropTypes.string,
  isMobile: PropTypes.bool,
  collections: PropTypes.arrayOf(productCollectionShape),
};

const mapStateToProps = (state) => ({
  isMobile: getWindowWidth(state) < 1024,
});

export default connect(mapStateToProps, null)(FeaturedProducts);
